// extracted by mini-css-extract-plugin
export default {"widgets_container":"widgetswrapper_widgets_container__NnGBl","widget_inner_container":"widgetswrapper_widget_inner_container__jE9sW"};